// extracted by mini-css-extract-plugin
export default {"link_item":"styles_link_item__wumP-","active__link":"styles_active__link__Bamir"};